import classnames from 'classnames';
import { createElement } from 'react';
CardHeader.defaultProps = {
    prefixCls: 'im-card',
    thumbStyle: {},
};
export default function CardHeader(props) {
    const { prefixCls, className, title, thumb, thumbStyle, extra, subTitle, subStyle, showHeadLine, ...restProps } = props;
    const wrapCls = classnames(`${prefixCls}-header`, className, {
        [`${prefixCls}-header-line`]: showHeadLine,
    });
    return (createElement("div", Object.assign({ className: wrapCls }, restProps),
        createElement("div", null,
            createElement("div", { className: `${prefixCls}-header-content` },
                typeof thumb === 'string' ? (createElement("img", { style: thumbStyle, src: thumb })) : (thumb),
                title),
            subTitle ? (createElement("div", { className: `${prefixCls}-header-subtitle`, style: subStyle }, subTitle)) : null),
        extra ? (createElement("div", { className: `${prefixCls}-header-extra` }, extra)) : null));
}
